export default "/_next/static/dabaf45b98038b603635416960834b34.jpg";